import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "right-3CAL4",
  "use": "right-3CAL4-usage",
  "viewBox": "0 0 4 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 4 9\" id=\"right-3CAL4\"><path fill-rule=\"evenodd\" d=\"M4.09 4.5L0 9V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol